import { z } from 'zod';
/** Required acknowledgment version when enabling governed draft reads (DC-379 / FR-008). */
export const DRAFT_READ_RISK_TERMS_VERSION = 'dc379-v1';
export const patchDraftReadPolicyRequestSchema = z
    .object({
    allow_hosted_mcp_draft_reads: z.boolean(),
    expected_policy_version: z.number().int().min(1),
    acknowledgment: z
        .object({
        accepted_risk_terms_version: z.string().min(1).max(64),
    })
        .optional(),
})
    .superRefine((val, ctx) => {
    if (val.allow_hosted_mcp_draft_reads) {
        const v = val.acknowledgment?.accepted_risk_terms_version;
        if (!v || v !== DRAFT_READ_RISK_TERMS_VERSION) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `acknowledgment.accepted_risk_terms_version must equal "${DRAFT_READ_RISK_TERMS_VERSION}" when enabling`,
                path: ['acknowledgment', 'accepted_risk_terms_version'],
            });
        }
    }
});
export const draftReadPolicyDtoSchema = z.object({
    organization_id: z.string().uuid(),
    allow_hosted_mcp_draft_reads: z.boolean(),
    policy_version: z.number().int().min(1),
    updated_at: z.string(),
    updated_by_user_id: z.string().uuid().nullable(),
    last_enabled_at: z.string().nullable(),
    last_disabled_at: z.string().nullable(),
});
export const draftReadPolicyOperatorDtoSchema = draftReadPolicyDtoSchema.extend({
    recent_denial_count_7d: z.number().int().min(0).optional(),
});
//# sourceMappingURL=draft-read-policy.js.map